// extracted by mini-css-extract-plugin
export default {"main":"main-LXY4I","reviewItem":"reviewItem-Qhp7k","loadMore":"loadMore-m5aQl","loadMoreText":"loadMoreText-ad4KS","disabled":"disabled-slnBU"};